"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetailThirdPartyReviewsContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const HtmlInclude_1 = require("../../components/common/html-include/HtmlInclude");
const common_components_1 = require("@as-react/common-components");
const react_redux_1 = require("react-redux");
const ProductSelector_1 = require("../../redux/product/selectors/ProductSelector");
const useFeatureToggle_1 = require("../../hooks/useFeatureToggle");
const useFeefoWidget_1 = require("../../hooks/useFeefoWidget");
const ProductDetailThirdPartyReviewsContainer = () => {
    const { review } = (0, common_components_1.useAemConfig)();
    const { productCode } = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetProductInfo)());
    const show_feefo_widget = (0, useFeatureToggle_1.useFeatureToggle)('show_feefo_widget');
    const { renderFeefoWidget } = (0, useFeefoWidget_1.useFeefoWidget)(productCode, show_feefo_widget);
    return show_feefo_widget ? (renderFeefoWidget()) : ((0, jsx_runtime_1.jsx)(HtmlInclude_1.HtmlInclude, { htmlFragment: `<reevoo-embeddable
              type="product"
              show-brand="${review.reevooShowBrand}"
              stars-enabled="${review.reevooStarsEnabled}"
              product-id="${productCode}"
              per-page="${review.amount}"/>` }));
};
exports.ProductDetailThirdPartyReviewsContainer = ProductDetailThirdPartyReviewsContainer;
